<template>
    <section class="dtk-estadio">
        <dtk-estadio-canvas :nivel="nivel" v-if="tem_setor" v-show="setor == ''" v-model="setor" :id_clube="id_clube"></dtk-estadio-canvas>

        <section v-show="setor != ''" class="campo"> 
            <div class="col">
                <div>
                    <div v-if="tem_setor" @click="stadium()" class="stadium">
                        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="33.8666mm" height="33.8666mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                        viewBox="0 0 3387 3387"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Camada_x0020_1">
                                <metadata id="CorelCorpID_0Corel-Layer"/>
                                <g id="_1596169822768">
                                    <path class="fil0" d="M1696 753c518,0 937,252 937,563 0,167 -121,317 -313,420 55,-61 86,-130 86,-204 0,-237 -319,-429 -714,-429 -394,0 -713,192 -713,429 0,71 28,138 79,196 -184,-102 -299,-249 -299,-412 0,-311 419,-563 937,-563z"/>
                                    <path class="fil0" d="M1381 2634c-236,-77 -433,-238 -555,-446l-72 -728c111,307 472,522 938,523 465,-1 826,-216 938,-523l-73 728c-122,208 -319,369 -555,446l0 -248c0,-33 -17,-60 -37,-60l-546 0c-21,0 -38,27 -38,60l0 248z"/>
                                    <path class="fil0" d="M1698 1147c256,0 645,188 645,420 0,125 -83,237 -216,314 38,-46 60,-98 60,-153 0,-177 -220,-320 -492,-320 -271,0 -491,143 -491,320 0,53 19,103 54,147 -126,-77 -206,-186 -206,-308 0,-232 289,-420 646,-420z"/>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <!-- <small v-if="tem_setor">Voltar</small>                 -->
                </div>
                <div class="info-estadio">
                    <div class="bullet">
                        <i class="fas fa-street-view"></i>
                    </div>
                    <div>
                        {{ stringSelecionados }}
                    </div>
                </div>
                <div @click="clear()" class="clear">
                    <i class="fas fa-trash-alt"></i>
                </div>
            </div>
            <div class="col">
            </div>
        </section>
        
        <div style="padding-top: 40px" v-show="setor != '' && tem_setor" v-if="setor !== null"> Setor: {{ setor.replace("/true", "") }} </div>

        <section v-show="setor != ''" class="estadio_select">
            <div class="estadio_control left" @click="move(-1)">
                <i class="fas fa-chevron-left"></i>
            </div>
            <div class="letters">
                <div class="letter" :key="row[0].id" v-for="row in cadeiras"> Fila {{ row[0].letra }} </div>
            </div>
            <div class="cadeiras">
                <div class="load" v-show="loading">
                    <h1>Buscando cadeiras...</h1>
                    <i class="fas fa-futbol"></i>
                </div>
                <div class="estadio_row" v-for="cadeiraRow of cadeiras" :key="cadeiraRow[0].id">
                    <div v-for="cadeira of cadeiraRow" :key="cadeira.id" :data-code="cadeira.code"
                            :class="cadeiraClasses(cadeira)" 
                            @click="reserve(cadeira)">
                            {{ cadeira.numero }}
                    </div>
                </div>
            </div>
            <div class="estadio_control right" @click="move(1)">
                <i class="fas fa-chevron-right"></i>
            </div>
        </section>

        <div v-show="!loading && setor != ''" style="background-color: #29a33d; padding: 10px; color: white; margin-top: 20px; margin-bottom: 20px; width: 80%; text-align: center;">
            {{ id_clube == 94 ? 'QUADRA' : 'CAMPO' }}
        </div>
        
        <section v-show="setor != ''" class="legenda">
            <ul>
                <li>
                    <span class="legenda-ball livre"></span>
                    <span>Livre</span>
                </li>
                <li>
                    <span class="legenda-ball reservada"></span>
                    <span>Reservada</span>
                </li>
                <li>
                    <span class="legenda-ball ocupada"></span>
                    <span>Ocupada</span>
                </li>
                <li>
                    <span class="legenda-ball selecionada"></span>
                    <span>Selecionada</span>
                </li>
                <li>
                    <span class="legenda-ball corredor"></span>
                    <span>Corredor</span>
                </li>
            </ul>
        </section>
    </section>
</template>

<script>
    import Vue from 'vue'
    export default Vue.extend({
        data() {
            return {
                cadeiras: [],
                index: 0,
                max: 0,
                perPage: 0,
                selecionados: [],
                loading: true,
                setor: '',
                setor_boolean: false
            }
        },
        props : {
            dependentes: {
                type: Array,
                default:  function() { return [] }
            },
            value: {
                type: String,
                default: ''
            },
            alreadySelected: {
                type: Array,
                default: function() { return [] }
            },
            id_clube: {
                type: String,
                default: '0'
            },
            tem_setor: {
                default: false
            },
            nivel: {
                default: 0
            }
        },
        watch: {
            setor: function() {
                if (this.setor != '') {
                    this.getCadeiras(this.setor)
                }
            }
        },
        computed : {
            stringSelecionados: function () {
                if (this.selecionados.length > 0) {
                    let strArr = this.selecionados[0].split('/')
                    return strArr[strArr.length - 1]
                } else {
                    return ''
                }
            }
        },
        mounted() {
            if (this.tem_setor == 1) {
                this.setor = ''
                this.setor_boolean = true
            } 
            else {
                this.setor = null
                this.setor_boolean = false 
                this.getCadeiras()
            }
            this.perPage = this.getPerPage()
        },
        methods: {
            cadeiraClasses(cadeira){
                return  {
                    'cadeira': true, 
                    'ocupado': cadeira.status == 'ocupada', 
                    'branco': cadeira.status == 'branco', 
                    'livre': cadeira.status == 'livre' || cadeira.status == 'selecionado', 
                    'reservado': cadeira.status == 'reservada' , 
                    'selecionado': cadeira.code == this.selecionados[0], 
                    'corredor': cadeira.status == 'corredor',
                    'selecionado_agora': this.alreadySelected.includes(cadeira.code)
                }
            },
            async getCadeiras(setor=null) {
                if (!this.tem_setor && setor == null) {
                    this.loading = true
                    this.cadeiras = []
                    const request = await Axios.get('/cadeiras/clube')
                    this.cadeiras = await request.data.data
                    this.cadeirasArr = [].concat.apply([], this.cadeiras)
                    this.loading = false
                    this.perPage = this.getPerPage()
                    this.max = (this.cadeiras[0].length * 25) / (this.perPage * 25) - 1
                    setTimeout(this.updateCadeiras, 20000)
                } else if (this.tem_setor && setor != null) {
                    this.loading = true
                    this.cadeiras = []
                    const request = await Axios.get('/api/estadio/secao/' + setor)
                    this.cadeiras = await request.data.data
                    this.cadeirasArr = [].concat.apply([], this.cadeiras)
                    this.loading = false
                    this.perPage = this.getPerPage()
                    this.max = (this.cadeiras[0].length * 25) / (this.perPage * 25)
                    setTimeout(this.updateCadeiras, 20000)
                }
                if(!isNaN(this.cadeiras[0][0].letra)) {
                    this.cadeiras.sort((cadeiraA, cadeiraB) => cadeiraA[0].letra - cadeiraB[0].letra)
                }

                for (const fileira of this.cadeiras) {
                    fileira.sort((a, b) => {
                        if (parseInt(a) > parseInt(b)) return 1
                        else if (parseInt(a) < parseInt(b)) return -1
                        else return 0
                    })
                }
            },
            async updateCadeiras(setor=null) {
                if (!this.tem_setor && setor == null) {
                    const request = await Axios.get('/cadeiras/clube')
                    this.cadeiras = await request.data.data
                    this.cadeirasArr = [].concat.apply([], this.cadeiras)
                    this.loading = false
                    this.max = (this.cadeiras[0].length) / (this.perPage)
                    setTimeout(this.updateCadeiras, 20000)
                } else if (this.tem_setor && setor != null) {
                    const request = await Axios.get('/api/estadio_secao/' + setor)
                    this.cadeiras = await request.data.data
                    this.cadeirasArr = [].concat.apply([], this.cadeiras)
                    this.loading = false
                    this.max = (this.cadeiras[0].length) / (this.perPage)
                    setTimeout(this.updateCadeiras, 20000)
                }

                if(!isNaN(this.cadeiras[0][0].letra)) {
                    this.cadeiras.sort((cadeiraA, cadeiraB) => cadeiraA[0].letra - cadeiraB[0].letra)
                }

                for (const fileira of this.cadeiras) {
                    fileira.sort((a, b) => {
                        if (parseInt(a) > parseInt(b)) {
                            return 1
                        } else if (parseInt(a) < parseInt(b)) {
                            return -1
                        } else {
                            return 0
                        }
                    })
                }
            },
            reserve(cadeira) {
                if(cadeira.status === 'livre' && this.selecionados.length == 0){
                    this.selecionados = [cadeira.code]
                    this.selecionados.push(cadeira.code)
                    cadeira.status = 'selecionado'
                    this.$emit('input', cadeira.code)
                } else if (cadeira.status === 'livre' && this.selecionados.length != 0) {
                    this.selecionados = [cadeira.code]
                    cadeira.status = 'selecionado'
                    this.$emit('input', cadeira.code)
                } else if (cadeira.status === 'selecionado') {
                    this.selecionados = []
                    cadeira.status = 'livre'
                    this.$emit('input', '')
                }
            },
            move(direction) {
                if (this.index == 0 && direction < 0) {
                    return
                }
        
                if (direction > 0 && -1 * (this.index - 1) <= this.max) {
                    this.index--
                    document.querySelectorAll('.estadio_row').forEach(element => {
                        element.style.transform = 'translateX(' + this.index * 100 + '%)'
                    })
                }
                
                if (direction < 0 && this.index < 0) {
                    this.index++
                    document.querySelectorAll('.estadio_row').forEach(element => {
                        element.style.transform = 'translateX(' + this.index * 100 + '%)'
                    })
                }
            },
            getPerPage(){
                if (window.matchMedia('(max-aspect-ratio: 1/1)').matches) {
                    document.querySelectorAll('section.estadio_select > div.cadeiras').forEach((el => {
                        el.style.width = '210px'
                    }))
                    return 6
                } else {
                    document.querySelectorAll('section.estadio_select > div.cadeiras').forEach((el => {
                        el.style.width = '560px'
                    }))
                    return 15
                }
            },
            clear(){
                this.selecionados = []
            },
            stadium(){
                this.setor = ''
            },
        }
    })
</script>
